import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/Marquee";
import { StudioCards } from "../components/StudioCards";
import { Manifesto } from "../components/Manifesto";
import { Reviews } from "../components/Reviews";
import { PresidentWord } from "../components/PresidentWord";
import { AirbnbBox } from "../components/AirbnbBox";
import { Seo } from "../components/Seo";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo titleKey="seo.home.title" descKey="seo.home.description" />
      <Hero />
      <EditorialMarquee />
      <StudioCards />
      <AirbnbBox />
      <Manifesto />
      <PresidentWord />
      <Reviews />
    </div>
  );
}
